<ion-item-sliding [disabled]="!showItemOptions" lines="none" class="ion-no-margin">
	<ion-item lines="none" class="ion-no-margin ion-no-padding">
		<ion-card mode="ios" class="ion-no-margin">
			<ion-card-content (click)="selectCard()" data-cy="selectCard">
				<ion-card-title *ngIf="cardData.title">
					<ion-grid class="ion-no-padding">
						<ion-row style="flex-wrap: wrap; align-items: center;">
							<ion-col size="12"
								style="display: flex; justify-content: space-between; align-items: center;">
								<div class="card-title-wrapper" style="flex: 1 1 auto; min-width: 0;">
									<ng-container *ngIf="cardData.title">{{ cardData.title }}</ng-container>
									<span *ngIf="cardData.secondTitle">{{ cardData.secondTitle }}</span>
								</div>
								<ion-buttons>
									<ion-button class="ion-no-padding" (click)="toggleExpandCollapse($event)">
										<ion-icon *ngIf="!cardData.isExpanded" class="icon-Arrow-Down"></ion-icon>
										<ion-icon *ngIf="cardData.isExpanded" class="icon-Arrow-Up"></ion-icon>
									</ion-button>
								</ion-buttons>
							</ion-col>
						</ion-row>
					</ion-grid>
				</ion-card-title>

				<div style="display: flex; justify-content: flex-end; width: 100%;">
					<ion-buttons *ngIf="!cardData.title">
						<ion-button class="ion-no-padding" (click)="toggleExpandCollapse($event)">
							<ion-icon *ngIf="!cardData.isExpanded" class="icon-Arrow-Down"></ion-icon>
							<ion-icon *ngIf="cardData.isExpanded" class="icon-Arrow-Up"></ion-icon>
						</ion-button>
					</ion-buttons>
				</div>

				<ion-grid class="ion-no-padding">
					<ion-row *ngFor="let property of cardData.properties | slice: 0 : 3"
						[ngClass]="property.isPrimaryKey ? 'primary-key' : ''">
						<ion-col class="ion-text-start" size="6">{{ property.label }}</ion-col>
						<ion-col class="ion-text-start" size="6">{{
							property.value | formatEntryItem: property.valueType
							}}</ion-col>
					</ion-row>
					<ion-row *ngFor="let property of cardData.properties | slice: 3 : 8; let i = index"
						[class.hidden-card]="!cardData.isExpanded" [class.primary-key]="property.isPrimaryKey">
						<ion-col class="ion-text-start" size="6">{{ property.label }}</ion-col>
						<ion-col class="ion-text-start" size="6">{{
							property.value | formatEntryItem: property.valueType
							}}</ion-col>
					</ion-row>
				</ion-grid>
			</ion-card-content>
			<div class="copy-check-buttons">
				<ng-content *ngIf="cardData.isValid"></ng-content>
			</div>
		</ion-card>
	</ion-item>
	<ion-item-options *ngIf="showItemOptions">
		<ng-container>
			<ion-item-option *ngIf="isParent" class="ion-no-border duplicate">
				<div>
					<ion-icon appThrottleButtonDirective [throttleTime]="2000" (eventTriggered)="newFrom($event)"
						data-cy="newFrom" class="ion-no-padding icon-Duplicate"></ion-icon>
					<ion-label>{{ 'entity.buttons.newFrom' | translate }}</ion-label>
				</div>
			</ion-item-option>
			<ion-item-option *ngIf="isDeleteActionAllowed" class="ion-no-border delete">
				<div>
					<ion-icon appThrottleButtonDirective [throttleTime]="2000" (eventTriggered)="deleteRecord($event)"
						data-cy="deleteRecord" class="ion-no-padding icon-Delete"></ion-icon>
					<ion-label>{{ 'entity.buttons.delete' | translate }}</ion-label>
				</div>
			</ion-item-option>
		</ng-container>
	</ion-item-options>
</ion-item-sliding>